import { render, staticRenderFns } from "./DraggableFilterTabsList.vue?vue&type=template&id=59f6f2a6&scoped=true"
import script from "./DraggableFilterTabsList.vue?vue&type=script&lang=js"
export * from "./DraggableFilterTabsList.vue?vue&type=script&lang=js"
import style0 from "./DraggableFilterTabsList.vue?vue&type=style&index=0&id=59f6f2a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f6f2a6",
  null
  
)

export default component.exports